import React, {useCallback, useMemo} from "react";
import Video from "../../../devices-rows/camera/Video";
import useCameraPresence from "../../../devices-rows/camera/useCameraPresence";
import {useSelector} from "react-redux";
import NewIOT from "../../../../IOT/NewIOT";
import useMQTTFetcher from "../../../../hooks/useMQTTFetcher";
import {getShadows} from "../../../../selectors/shadowSelectors";
import {normalizeStreamObject} from "../../../../selectors/device-rows/cameraSelector";

const CameraContent = ({device, selectStreamId}) => {
    const shadows = useSelector(getShadows);

    const shadow = device?.DevID ? shadows.get(device.DevID) : null;

    const handleHide = useCallback(() => {
        selectStreamId(null);
    }, [selectStreamId]);

    const selected = useMemo(() => {
        if (!device) return null;
        return normalizeStreamObject({device, shadow});
    }, [device, shadow]);

    const fetchData = useCallback(() => {
        if (device) {
            const {DevID, GatewayID} = device;
            NewIOT.startSendingDeviceState({DevID, GatewayID});
        }
    }, [device]);

    useMQTTFetcher(fetchData);

    useCameraPresence(selected?.gatewayId ?? null, selected?.streamId ?? null);

    if (!selected) {
        return null;
    }

    return (
        <Video
            streamId={selected.streamId}
            forcePictureInPicture
            isStreamLive={selected.isStreamLive}
            onCloseClick={handleHide}
        />
    );
};

export default CameraContent;
